import { makeStyles, tokens, Body1, Button, Title3 } from '@fluentui/react-components';
import { BoxRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingVerticalXXXL,
    textAlign: 'center',
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: tokens.borderRadiusLarge,
    border: `1px dashed ${tokens.colorNeutralStroke2}`,
  },
  icon: {
    fontSize: '64px',
    color: tokens.colorNeutralForeground4,
    marginBottom: tokens.spacingVerticalL,
  },
  title: {
    marginBottom: tokens.spacingVerticalS,
    color: tokens.colorNeutralForeground2,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalL,
    maxWidth: '400px',
  },
});

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({
  icon = <BoxRegular />,
  title,
  description,
  action,
}: EmptyStateProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.icon}>{icon}</div>
      <Title3 className={styles.title}>{title}</Title3>
      {description && <Body1 className={styles.description}>{description}</Body1>}
      {action && (
        <Button appearance="primary" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
